import React, { useCallback, useContext, useRef, useState } from 'react'
import { Col, Row, Card, Form, Button, Spinner } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { useCookies } from 'react-cookie'
import { useLocation } from 'react-router-dom'
import { Context } from '../Statistic'
import { exportAllStatistic } from '../../../../controller/api/__classic__/statistic-by-ticket'
import { exportClassicTicketStatisticToExcel } from '../../../../helpers/excelExport'
import { parseQuery } from '../../../../helper/helper'

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);
  const [cookies] = useCookies(['lottmekong']);
  const location = useLocation();

  const [isExporting, setIsExporting] = useState(false);

  const _phone = useRef(state.filter.phone);

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _submitForm = useCallback((e) => {
    if (e) e.preventDefault();
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        phone: _phone.current
      }
    })
  }, [dispatch])

  const handleExportExcel = async () => {
    const queryObj = parseQuery(location.search)

    if (!queryObj.resultId) {
      alert('Không xác định được kỳ quay số để xuất file')
      return
    }

    let phone = state.filter.phone

    if (phone.indexOf('MB') < 0) {
      phone = phone.replace('0', '+84')
    }

    setIsExporting(true)
    try {
      const response = await exportAllStatistic(cookies.lottmekong, {
        phone: phone,
        resultId: queryObj.resultId
      })

      if (response && response.data) {
        exportClassicTicketStatisticToExcel(response.data, state.filter)
      }
    } catch (error) {
      console.error('Export failed:', error)
      alert('Xuất Excel thất bại. Vui lòng thử lại!')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Card border="light" className="shadow-sm">
      <Card.Body>
        <Form onSubmit={_submitForm}>
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Số điện thoại</Form.Label>
                <Form.Control
                  defaultValue={state.filter.phone}
                  onChange={_handleChangePhone}
                  type="text"
                  placeholder="Nhập số điện thoại"
                />
              </Form.Group>
            </Col>
            <Col md={8} className="d-flex align-items-end mb-3">
              <Button variant="primary" type="submit" className="me-2" style={{ marginRight: '10px' }}>
                Tìm kiếm
              </Button>
              <Button
                variant="success"
                type="button"
                disabled={isExporting}
                onClick={handleExportExcel}
              >
                {isExporting ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Đang xuất...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faFileExcel} className="me-2" />
                    Xuất Excel
                  </>
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default React.memo(_FilterForm)
